{
	"ariaCloseDialog": "Close Dialog",
	"ariaGoBack": "Go Back"
}
